import React from 'react';
import parse from 'html-react-parser';

const SectionHtml = ({ content }) => (
    <div className='w-full overflow-auto [&_a]:underline [&>*:not(p)]:py-4'>{parse(content)}</div>
);

export default SectionHtml;
